module.exports = __webpack_public_path__ + "Raleway.580d0778ad254335be45.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Raleway.ttf
// module id = 374
// module chunks = 8